export default "__VITE_ASSET__UA$xJvX1__"